module.exports = __webpack_public_path__ + "img/aboutUs.8dcc3590.jpg";